<div class="m-b-5">{{{pagination}}}</div>
<div class="card-box clearfix">
    <div class="row col-lg-12">
        {{#each items}}
            <div class="row js-alarm-item">
                <div class="col-xs-2">
                    <div class="m-l-10">
                        <input data-occurence-idx="{{@index}}" class="js-alarm-select" type="checkbox" {{#if selected}}checked="checked"{{/if}}></input>
                        <br>
                        {{#if is_triggered}}
                        <i class="fa fa-exclamation-triangle" title="{{TR "Alarm wurde behoben"}}"></i>
                        {{else}}
                        <i class="fa fa-exclamation-triangle error" title="{{TR "Alarm dauert an"}}"></i>
                        {{/if}}
                        <br>
                        {{#if is_email}}
                        <i class="fa fa-envelope-o" title="{{TR "Eine E-Mail-Benachrichtigung wurde verschickt."}}"></i>
                        {{/if}}
                        {{#if is_sms}}
                            <i class="fa fa-comment" title="{{TR "Eine SMS-Benachrichtigung wurde verschickt."}}"></i>
                        {{/if}}
                    </div>
                </div>
                <div class="col-xs-8">
                    {{#if ../alarm_name_visible}}
                    <div class="row col-xs-12 no-br">
                        <dd><i class="fa fa-bell-o"></i></dd>
                        <dt>{{alarm_name}}</dt>
                    </div>
                    {{/if}}
                    {{#if ../device_name_visible}}
                    <div class="row col-xs-12 no-br">
                        {{{DEVICE_STATUS device_status}}}
                        {{#if can_see_device}}<a href="{{device_link}}">{{/if}}
                        {{device_name}}
                        {{#if can_see_device}}</a>{{/if}}
                    </div>
                    {{/if}}
                    <div class="row">
                        <div class="col-xs-6">
                            <dd>{{TR "Ausgelöst"}}</dd>
                            <dt>{{TIME triggered_time}}</dt>
                        </div>
                        <div class="col-xs-6">
                            <dd>{{TR "Behoben"}}</dd>
                            <dt>{{#if is_active}}{{TIMEEX corrected_time}}{{else}}{{#COMPARE corrected_time '>=' triggered_time}}{{TIMEEX corrected_time}}{{else}}{{TR "abgebrochen"}}{{/COMPARE}}{{/if}}</dt>
                        </div>
                    </div>
                    {{#if ../priority_text_visible}}
                    <div class="row col-xs-12">
                        <dd>{{TR "Priorität"}}:</dd>
                        <dt>{{priority}}</dt>
                    </div>
                    <div class="row col-xs-12 m-t-10">
                        {{{cond_text}}}
                    </div>

                    {{/if}}
                </div>
                <div class="col-xs-2">
                    {{#unless is_acknowledged}}
                    <button class="btn btn-sm btn-white js-alarm-acknowledge" data-occurence-id="{{id}}">
                        <i class="fa fa-bell"></i>
                    </button>
                    {{/unless}}
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <hr>
                </div>
            </div>
        {{/each}}
            <div class="row m-b-5">
                <div class="col-xs-2">
                    <div class="m-l-10">
                        <input id="chkSelectAll" class="js-alarm-select-all" type="checkbox"></input>
                    </div>
                </div>
                <div class="col-xs-10">
                    <label for="chkSelectAll">{{TR "Alle auswählen/abwählen"}}</label>
                </div>
            </div>
    </div>
    <div class="btn-group m-b-20">
        <button class="btn-default btn js-alarm-sel-acknowledge">{{TR "Quittieren"}}</button>
        <button class="btn-default btn js-alarm-sel-delete">{{TR "Löschen"}}</button>
    </div>
</div>
